import React, { useEffect, useRef } from "react";
import chatAgentImage from "../../../_images/chat-agent-image.jpg";
import PropTypes from "prop-types";
import Five9Widget from "./Five9Widget";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

const ChatBotIcon = ({ open, setOpen, showGetExpertIcon }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const isSpeed = location.pathname.includes("speed");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const observerRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const openedAt = Date.now();

    // Poll until Five9 widget container appears
    const pollId = setInterval(() => {
      const five9Container =
        document.querySelector("#five9-frame") ||
        document.querySelector("[class*='five9'][class*='container']") ||
        document.querySelector("[id*='five9']");

      if (!five9Container) return;

      clearInterval(pollId);

      // Watch for Five9 hiding/closing its container
      observerRef.current = new MutationObserver(() => {
        const isHidden =
          five9Container.style.display === "none" ||
          five9Container.style.visibility === "hidden" ||
          five9Container.classList.contains("minimized") ||
          five9Container.classList.contains("hidden") ||
          five9Container.classList.contains("closed");

        // Ignore initial transient hidden styles while Five9 frame is mounting.
        if (isHidden && Date.now() - openedAt > 1500) {
          setOpen(false);
        }
      });

      observerRef.current.observe(five9Container, {
        attributes: true,
        attributeFilter: ["style", "class"],
      });
    }, 300);

    return () => {
      clearInterval(pollId);
      observerRef.current?.disconnect();
    };
  }, [open, setOpen]);

  const handleToggle = () => {
    setOpen((prev) => !prev);
  };

  return (
    <>
      {showGetExpertIcon && (
        <>
          {/* Chat Button */}
          <div
            style={{
              position: "fixed",
              right: "20px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              zIndex: 9999,
              cursor: "pointer",
              bottom: isMobile ? "40px" : "20px",
            }}
            onClick={handleToggle}
          >
            {/* Circle Image Button */}
            <div
              style={{
                width: "60px",
                height: "60px",
                borderRadius: "50%",
                overflow: "hidden",
                boxShadow: "0 6px 16px rgba(0,0,0,0.3)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#1A365E",
              }}
            >
              <img
                src={chatAgentImage}
                alt="chat"
                style={{
                  width: "85%",
                  height: "85%",
                  objectFit: "cover",
                  display: "block",
                  borderRadius: "50%",
                }}
              />
            </div>

            <div
              style={{
                marginTop: "-5px",
                fontSize: "12px",
                fontWeight: "500",
                color: "#fff",
                background: "#1A365E",
                padding: "3px 8px",
                borderRadius: "12px",
                boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                whiteSpace: "nowrap",
              }}
            >
              {t("steps.getExpertHelp")}
            </div>
          </div>
        </>
      )}

      <Five9Widget open={open} setOpen={setOpen} isSpeed={isSpeed} />
    </>
  );
};

ChatBotIcon.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  showGetExpertIcon: PropTypes.bool,
};

export default ChatBotIcon;
